import React, { useState, useEffect, useCallback, useContext } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import {
	Checkbox,
	CircularProgress,
	Divider,
	InputLabel,
	Modal,
	Step,
	StepContent,
	StepLabel,
	Stepper,
	TextField,
} from "@mui/material";
import Cart1 from "../../assets/cart1.png";
import Cart1NoCoupon from "../../assets/cart1-nocoupon.png";
import Cart2 from "../../assets/cart2.png";
import Cart3 from "../../assets/cart3.png";
import Cart4 from "../../assets/cart4.png";
import Cart5 from "../../assets/cart5.png";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { ADMIN_URL } from "../../utils/constants";
import { InfoCircle } from "tabler-icons-react";
import Step1 from "../../assets/step1.png";
import Step2 from "../../assets/step2.png";
import Step3 from "../../assets/step3.png";
import { UserContext } from "../../context/UserContext";
import { useAlert } from "react-alert";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardForm: {
		display: "flex",
		overflow: "auto",
		padding: 20,
	},
	cardGrid: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
});

export default function BookingProcess({ drawerWidth }) {
	const classes = useStyles();

	const [loading, setLoading] = useState(false);
	const [showCoupon, setShowCoupon] = useState(true);
	const [shippingMethod, setShippingMethod] = useState("");
	const [shippingAddress, setShippingAddress] = useState("");
	const [shippingBillingAddress, setShippingBillingAddress] = useState("");
	const [cartCreditCard, setCartCreditCard] = useState("");
	const [platformSettings, setPlatformSettings] = useState("");
	const [stripeKey, setStripeKey] = useState("");
	const [stripePublicKey, setStripePublicKey] = useState("");
	const [stripeWebhook, setStripeWebhook] = useState("");
	const [showStripeModal, setShowStripeModal] = useState(false);
	const [showStripePublicModal, setShowStripePublicModal] = useState(false);
	const [showStripeWebhookModal, setShowStripeWebhookModal] = useState(false);
	const { t } = useTranslation();
	const alert = useAlert();
	const { user } = useContext(UserContext);

	const saveCartData = useCallback(async () => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					useCoupon: showCoupon,
					cartShippingAddress: shippingAddress,
					cartShippingMethod: shippingMethod,
					cartShippingBillingAddress: shippingBillingAddress,
					cartCreditCard: cartCreditCard,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			await axios.put(
				ADMIN_URL + "platformSettings/" + platformSettings.id,
				{
					stripeKey: stripeKey,
					stripePublicKey: stripePublicKey,
					stripeWebhook: stripeWebhook,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	}, [
		showCoupon,
		shippingAddress,
		shippingMethod,
		shippingBillingAddress,
		cartCreditCard,
		platformSettings,
		stripeKey,
	]);

	useEffect(() => {
		const getCartData = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "creators", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setShowCoupon(res.data.useCoupon);
				setShippingMethod(res.data.cartShippingMethod);
				setShippingAddress(res.data.cartShippingAddress);
				setShippingBillingAddress(res.data.cartShippingBillingAddress);
				setCartCreditCard(res.data.cartCreditCard);
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};
		const getStripeKey = async () => {
			setLoading(true);
			try {
				const res = await axios.get(ADMIN_URL + "platformSettings", {
					headers: { authorization: localStorage.getItem("token") },
				});
				setPlatformSettings(res.data[0]);
				setStripeKey(res.data[0].stripeKey);
				setStripePublicKey(res.data[0].stripePublicKey);
				setStripeWebhook(res.data[0].stripeWebhook);
			} catch (error) {
				console.log(error);
			}
			setLoading(false);
		};

		getCartData();
		getStripeKey();
	}, []);

	return (
		<>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					bgcolor: "background.default",
					p: 3,
					width: "calc(100vw - " + drawerWidth + "px)",
				}}
			>
				<Toolbar />

				<Card variant="outlined">
					<>
						<CardContent>
							<Typography
								sx={{
									fontSize: 14,
									borderBottom: "1px solid #f0f0f0",
									height: "35px",
									marginBottom: "20px",
									marginLeft: "-20px",
									marginRight: "-20px",
									padding: "0px 20px",
								}}
								color="text.secondary"
								gutterBottom
							>
								Your cart process
							</Typography>
							<div className={classes.cardInfo}>
								<div container className={classes.cardForm}>
									<div
										item
										xs={12}
										sm={2}
										direction="column"
										className={classes.cardGrid}
									>
										<Typography
											sx={{
												marginBottom: "20px",
											}}
											color="text.secondary"
										>
											Page 1
										</Typography>

										<img
											src={showCoupon ? Cart1 : Cart1NoCoupon}
											alt="iphone"
											className={classes.iphone}
										/>
									</div>
									<div
										item
										xs={12}
										sm={2}
										direction="column"
										className={classes.cardGrid}
									>
										<Typography
											sx={{
												marginBottom: "20px",
											}}
											color="text.secondary"
										>
											Page 2
										</Typography>
										<img src={Cart2} alt="iphone" className={classes.iphone} />
									</div>
									<div
										item
										xs={12}
										sm={2}
										direction="column"
										className={classes.cardGrid}
									>
										<Typography
											sx={{
												marginBottom: "20px",
											}}
											color="text.secondary"
										>
											Page 3
										</Typography>
										<img src={Cart3} alt="iphone" className={classes.iphone} />
									</div>
									<div
										item
										xs={12}
										sm={2}
										direction="column"
										className={classes.cardGrid}
									>
										<Typography
											sx={{
												marginBottom: "20px",
											}}
											color="text.secondary"
										>
											Page 4
										</Typography>
										<img src={Cart4} alt="iphone" className={classes.iphone} />
									</div>
									<div
										item
										xs={12}
										sm={2}
										direction="column"
										className={classes.cardGrid}
									>
										<Typography
											sx={{
												marginBottom: "20px",
											}}
											color="text.secondary"
										>
											Page 5
										</Typography>
										<img src={Cart5} alt="iphone" className={classes.iphone} />
									</div>
								</div>
							</div>
							<div style={{ paddingLeft: 20 }}>
								<Typography
									sx={{
										fontSize: 12,
										marginTop: 2,
										marginBottom: 0,
										fontWeight: 700,
										textTransform: "uppercase",
									}}
									color="text.secondary"
									gutterBottom
								>
									Choose options
								</Typography>
								<FormControl
									fullWidth
									variant="standard"
									sx={{ marginTop: 2, marginBottom: 2 }}
								>
									<FormControlLabel
										control={
											<Checkbox
												id="app-button"
												checked={showCoupon}
												onChange={(e) => {
													setShowCoupon(!showCoupon);
												}}
											/>
										}
										label="Enable discount code"
									/>
								</FormControl>
								<FormControl
									fullWidth
									variant="standard"
									sx={{ marginTop: 2, marginBottom: 2 }}
								>
									<InputLabel
										shrink
										htmlFor="app-name-input"
										sx={{
											marginTop: -2,
											fontWeight: 700,
											textTransform: "uppercase",
											fontSize: 12,
										}}
									>
										{t("cart.shippingAddress")}
									</InputLabel>
									<TextField
										id="app-name-input"
										fullWidth
										variant="outlined"
										value={shippingMethod}
										onChange={(e) => {
											setShippingMethod(e.target.value);
										}}
									/>
								</FormControl>
								<FormControl
									fullWidth
									variant="standard"
									sx={{ marginTop: 2, marginBottom: 2 }}
								>
									<InputLabel
										shrink
										htmlFor="app-name-input"
										sx={{
											marginTop: -2,
											fontWeight: 700,
											textTransform: "uppercase",
											fontSize: 12,
										}}
									>
										{t("cart.shippingAddress")}
									</InputLabel>
									<TextField
										id="app-name-input"
										fullWidth
										variant="outlined"
										value={shippingAddress}
										onChange={(e) => {
											setShippingAddress(e.target.value);
										}}
									/>
								</FormControl>
								<FormControl
									fullWidth
									variant="standard"
									sx={{ marginTop: 2, marginBottom: 2 }}
								>
									<InputLabel
										shrink
										htmlFor="app-name-input"
										sx={{
											marginTop: -2,
											fontWeight: 700,
											textTransform: "uppercase",
											fontSize: 12,
										}}
									>
										{t("cart.billingAddress")}
									</InputLabel>
									<TextField
										id="app-name-input"
										fullWidth
										variant="outlined"
										value={shippingBillingAddress}
										onChange={(e) => {
											setShippingBillingAddress(e.target.value);
										}}
									/>
								</FormControl>
								<FormControl
									fullWidth
									variant="standard"
									sx={{ marginTop: 2, marginBottom: 2 }}
								>
									<InputLabel
										shrink
										htmlFor="app-name-input"
										sx={{
											marginTop: -2,
											fontWeight: 700,
											textTransform: "uppercase",
											fontSize: 12,
										}}
									>
										{t("cart.inputCreditCard")}
									</InputLabel>
									<TextField
										id="app-name-input"
										fullWidth
										variant="outlined"
										value={cartCreditCard}
										onChange={(e) => {
											setCartCreditCard(e.target.value);
										}}
									/>
								</FormControl>
								<Divider sx={{ marginBottom: 4, marginTop: 2 }} />
								<Typography
									sx={{
										fontSize: 12,
										marginTop: 2,
										marginBottom: 4,
										fontWeight: 700,
										textTransform: "uppercase",
									}}
									color="text.secondary"
									gutterBottom
								>
									Stripe configuration{" "}
									<small>(Required in order to accept payments)</small>
								</Typography>
								<FormControl
									fullWidth
									variant="standard"
									sx={{ marginTop: 2, marginBottom: 2 }}
								>
									<InputLabel
										shrink
										htmlFor="stripe-key-input"
										sx={{
											marginTop: -2,
											fontWeight: 700,
											textTransform: "uppercase",
											fontSize: 12,
											display: "flex",
											alignItems: "center",
										}}
									>
										{t("cart.stripeRestrictedSecretKey")}{" "}
										<InfoCircle
											style={{ marginLeft: 5, cursor: "pointer" }}
											size={16}
											onClick={() => {
												setShowStripeModal(true);
											}}
										/>
									</InputLabel>
									<TextField
										id="stripe-key-input"
										fullWidth
										variant="outlined"
										value={stripeKey}
										onChange={(e) => {
											setStripeKey(e.target.value);
										}}
									/>
								</FormControl>
								<FormControl
									fullWidth
									variant="standard"
									sx={{ marginTop: 2, marginBottom: 2 }}
								>
									<InputLabel
										shrink
										htmlFor="stripe-public-input"
										sx={{
											marginTop: -2,
											fontWeight: 700,
											textTransform: "uppercase",
											fontSize: 12,
											display: "flex",
											alignItems: "center",
										}}
									>
										{t("cart.stripePublicSecret")}{" "}
										<InfoCircle
											style={{ marginLeft: 5, cursor: "pointer" }}
											size={16}
											onClick={() => {
												setShowStripePublicModal(true);
											}}
										/>
									</InputLabel>
									<TextField
										id="stripe-public-input"
										fullWidth
										variant="outlined"
										value={stripePublicKey}
										onChange={(e) => {
											setStripePublicKey(e.target.value);
										}}
									/>
								</FormControl>
								<FormControl
									fullWidth
									variant="standard"
									sx={{ marginTop: 2, marginBottom: 2 }}
								>
									<InputLabel
										shrink
										htmlFor="stripe-webhook-input"
										sx={{
											marginTop: -2,
											fontWeight: 700,
											textTransform: "uppercase",
											fontSize: 12,
											display: "flex",
											alignItems: "center",
										}}
									>
										{t("cart.stripeWebhookSecret")}{" "}
										<InfoCircle
											style={{ marginLeft: 5, cursor: "pointer" }}
											size={16}
											onClick={() => {
												setShowStripeWebhookModal(true);
											}}
										/>
									</InputLabel>
									<TextField
										id="stripe-webhook-input"
										fullWidth
										variant="outlined"
										value={stripeWebhook}
										onChange={(e) => {
											setStripeWebhook(e.target.value);
										}}
									/>
								</FormControl>
							</div>
						</CardContent>
						{!["building", "built", "publishing"].find(
							(status) =>
								status ===
								(user.app.appStatuses.length === 0
									? ""
									: user.app.appStatuses.length > 0 &&
									  user.app.appStatuses[0].status)
						) && (
							<CardActions sx={{ justifyContent: "right" }}>
								<Button
									variant="contained"
									size="small"
									onClick={saveCartData}
									disabled={loading}
								>
									{loading ? <CircularProgress size={12} /> : t("general.save")}
								</Button>
							</CardActions>
						)}
					</>
				</Card>
			</Box>
			<div>
				<Modal
					open={showStripeModal}
					onClose={() => {
						setShowStripeModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							Stripe configuration
						</Typography>
						<Stepper
							orientation="vertical"
							color="#232323"
							sx={{ marginTop: 4 }}
							nonLinear
						>
							<Step key={0} active={true}>
								<StepLabel>
									Go to{" "}
									<a
										href="https://dashboard.stripe.com/register"
										target={"_blank"}
										rel="noreferrer"
									>
										Stripe
									</a>{" "}
									and create an account.
								</StepLabel>
							</Step>
							<Step key={1} active={true}>
								<StepLabel>
									After that, init session in the{" "}
									<a
										href="https://dashboard.stripe.com/login"
										target={"_blank"}
										rel="noreferrer"
									>
										Stripe Dashboard
									</a>
									.
								</StepLabel>
							</Step>
							<Step key={2} active={true}>
								<StepLabel>
									Once in, navigate to the{" "}
									<a
										href="https://dashboard.stripe.com/test/apikeys/create"
										target={"_blank"}
										rel="noreferrer"
									>
										API keys creation page
									</a>
									.
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step1} alt="step1" />
								</StepContent>
							</Step>
							<Step key={3} active={true}>
								<StepLabel>
									Add a key name like "Applaby Key" and{" "}
									<b>only toggle "Write" permissions on charges.</b>
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step2} alt="step2" />
								</StepContent>
							</Step>
							<Step key={4} active={true}>
								<StepLabel>
									Copy the generated API key and paste it in the input on this
									page.
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step3} alt="step3" />
								</StepContent>
							</Step>
						</Stepper>
					</Box>
				</Modal>
				<Modal
					open={showStripePublicModal}
					onClose={() => {
						setShowStripePublicModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							Stripe configuration
						</Typography>
						<Stepper
							orientation="vertical"
							color="#232323"
							sx={{ marginTop: 4 }}
							nonLinear
						>
							<Step key={0} active={true}>
								<StepLabel>
									Go to{" "}
									<a
										href="https://dashboard.stripe.com/register"
										target={"_blank"}
										rel="noreferrer"
									>
										Stripe
									</a>{" "}
									and create an account.
								</StepLabel>
							</Step>
							<Step key={1} active={true}>
								<StepLabel>
									After that, init session in the{" "}
									<a
										href="https://dashboard.stripe.com/login"
										target={"_blank"}
										rel="noreferrer"
									>
										Stripe Dashboard
									</a>
									.
								</StepLabel>
							</Step>
							<Step key={2} active={true}>
								<StepLabel>
									Once in, navigate to the{" "}
									<a
										href="https://dashboard.stripe.com/test/apikeys/create"
										target={"_blank"}
										rel="noreferrer"
									>
										API keys creation page
									</a>
									.
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step1} alt="step1" />
								</StepContent>
							</Step>
							<Step key={3} active={true}>
								<StepLabel>
									Add a key name like "Applaby Key" and{" "}
									<b>only toggle "Write" permissions on charges.</b>
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step2} alt="step2" />
								</StepContent>
							</Step>
							<Step key={4} active={true}>
								<StepLabel>
									Copy the generated API key and paste it in the input on this
									page.
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step3} alt="step3" />
								</StepContent>
							</Step>
						</Stepper>
					</Box>
				</Modal>
				<Modal
					open={showStripeWebhookModal}
					onClose={() => {
						setShowStripeWebhookModal(false);
					}}
				>
					<Box
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							width: 800,
							bgcolor: "background.paper",
							boxShadow: 24,
							p: 4,
							maxHeight: "calc(100% - 80px)",
							overflow: "auto",
						}}
					>
						<Typography id="modal-modal-title" variant="h6" component="h2">
							Stripe configuration
						</Typography>
						<Stepper
							orientation="vertical"
							color="#232323"
							sx={{ marginTop: 4 }}
							nonLinear
						>
							<Step key={0} active={true}>
								<StepLabel>
									Go to{" "}
									<a
										href="https://dashboard.stripe.com/register"
										target={"_blank"}
										rel="noreferrer"
									>
										Stripe
									</a>{" "}
									and create an account.
								</StepLabel>
							</Step>
							<Step key={1} active={true}>
								<StepLabel>
									After that, init session in the{" "}
									<a
										href="https://dashboard.stripe.com/login"
										target={"_blank"}
										rel="noreferrer"
									>
										Stripe Dashboard
									</a>
									.
								</StepLabel>
							</Step>
							<Step key={2} active={true}>
								<StepLabel>
									Once in, navigate to the{" "}
									<a
										href="https://dashboard.stripe.com/test/apikeys/create"
										target={"_blank"}
										rel="noreferrer"
									>
										API keys creation page
									</a>
									.
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step1} alt="step1" />
								</StepContent>
							</Step>
							<Step key={3} active={true}>
								<StepLabel>
									Add a key name like "Applaby Key" and{" "}
									<b>only toggle "Write" permissions on charges.</b>
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step2} alt="step2" />
								</StepContent>
							</Step>
							<Step key={4} active={true}>
								<StepLabel>
									Copy the generated API key and paste it in the input on this
									page.
								</StepLabel>
								<StepContent>
									<img style={{ maxWidth: "100%" }} src={Step3} alt="step3" />
								</StepContent>
							</Step>
						</Stepper>
					</Box>
				</Modal>
			</div>
		</>
	);
}
